import en from "./collectionEn.json";
import ja from "./collectionJa.json";
import kr from "./collectionKr.json";

export const collectionLocales = { en, ja, kr };